export const SECURITY_CHANGE_ATTRIBUTE = 'SECURITY_CHANGE_ATTRIBUTE';
